<script setup lang="ts">
import type { CmsElementVideoBox } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementVideoBox;
  class: any;
  style: any;
}>();

const { heading, thumbnail, video } = props.content?.config

const img = useImage()

const injectVideo = ref(false);

const imgUrl = img(thumbnail.value?.url, { height: 600, format: 'webp' })

const setVideo = () => {
  injectVideo.value = true;
  var v = document.getElementById('video');
  v.play();
}

</script>

<template>
  <section class="section section-video" :style="props.style" :class="props.class">
    <div class="container mb-4">
      <div class="video">
        <video @click="setVideo()" controls id="video" :poster="imgUrl">
          <source v-if="injectVideo" :src="video.value?.url" type="video/mp4">
        </video>
      </div><!-- /.video -->
    </div>
  </section><!-- /.section section-video -->
</template>

